import { render } from "./FavoriteGroupModal.vue?vue&type=template&id=31a50080&scoped=true"
import script from "./FavoriteGroupModal.vue?vue&type=script&lang=js"
export * from "./FavoriteGroupModal.vue?vue&type=script&lang=js"

import "./FavoriteGroupModal.vue?vue&type=style&index=0&id=31a50080&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a50080"]])

export default __exports__